import antdEn from 'antd/lib/locale-provider/en_US';
import viMessages from '../locales/vi_VN.json';
const ViLang = {
  messages: {
    ...viMessages,
  },
  antd: antdEn,
  locale: 'vi-VN',
};
export default ViLang;
